import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { StudioSlotName, useStudioSlots } from './StudioLayout';

interface StudioSlotProps {
  name: StudioSlotName;
  children: ReactNode;
}

// Portals the given children into the matching DOM slot exposed by
// <StudioLayout />. If the slot hasn't mounted yet (very first render before
// refs settle), nothing is portalled — React will re-render once the slot's
// callback ref fires and the portal becomes active.
export const StudioSlot = ({ name, children }: StudioSlotProps) => {
  const slots = useStudioSlots();
  const target = slots[name];
  if (!target) return null;
  return createPortal(children, target);
};

export default StudioSlot;
